import { render, staticRenderFns } from "./SelectField.vue?vue&type=template&id=6e22d0c4&scoped=true"
import script from "./SelectField.vue?vue&type=script&lang=js"
export * from "./SelectField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e22d0c4",
  null
  
)

export default component.exports